import R from 'ramda';

export const baseQuestions = {
    firstName: {
      type: 'string',
      title: 'First name',
      required: true
    },
    lastName: {
      type: 'string',
      title: 'Last name',
      required: true
    },
    email: {
      type: 'string',
      title: 'Email',
      required: true
    },
    secondaryEmail: {
        type: 'string',
        title: 'University email',
        required: true
    }
};

export const baseWidgets = {
};

export const baseUiSchema = {
    email: {
        format: 'email'
    },
    secondaryEmail: {
        format: 'email'
    },
    label: {
        'ui:widget': 'label'
    }
};

export default (standardQuestions, uiSchema, extraQuestions) => {
    const sortedQuestions = extraQuestions? extraQuestions.sort((a,b)=> a.order - b.order) : [];
    const properties = R.merge(
        standardQuestions,
        R.addIndex(R.reduce)(
            (properties, {node: {type, title, schema}}, index) => (
                R.assoc(`question-${R.inc(index)}`, {type, title, ...schema}, properties)
            ),
            {},
            sortedQuestions
        )
    );

    const defaultUiSchema = R.merge(
        uiSchema,
        R.addIndex(R.reduce)(
            (properties, {node: {ui: {widget, ...restUi}}}, index) => (
                R.assoc(`question-${R.inc(index)}`, {'ui:widget': widget, ...restUi}, properties)
            ),
            {},
            sortedQuestions
        )
    );

    const required = R.keys(R.filter((property) => R.equals(property.required, true), properties));

    return {
        defaultSchema: {
            type: 'object',
            required,
            properties
        },
        defaultUiSchema
    };
};



/** WEBPACK FOOTER **
 ** ./src/ApplicationForm/schema-builder.js
 **/